import React, { useEffect, useState } from 'react';
import Dialog from '../../../../Components/Dialog';
import useTranslate from '../../../../Hooks/useTranslate';
import DbeDatePicker from '../../../../Components/Inputs/DbeDatePicker';
import { formatWavePeriodValue } from '../../../../Utils/constants/general';

const WavePeriodDialog = function WavePeriodDialog({
  open,
  close,
  onSubmit,
  date = null,
}) {
  const translate = useTranslate();
  const [period, setPeriod] = useState(date);

  useEffect(() => {
    if (open) setPeriod(date);
  }, [open, date]);

  const handleAcceptPeriod = () => {
    if (!period) return;

    if (onSubmit) onSubmit(formatWavePeriodValue(period));
  };

  return (
    <Dialog open={open} onClose={close} title="WAVEPERIOD">
      <DbeDatePicker
        disableFuture
        staticPicker
        date={period}
        onChange={(newDate) => {
          setPeriod(newDate);
        }}
        localeText={{ datePickerToolbarTitle: translate('PERIOD') }}
        views={['month', 'year']}
        orientation="portrait"
        slotProps={{
          layout: {
            sx: { display: 'flex', flexDirection: 'column' },
          },
          actionBar: { onClick: handleAcceptPeriod },
        }}
        slots={{
          actionBar: null,
        }}
      />
    </Dialog>
  );
};

export default WavePeriodDialog;
